import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CLSpinner from '../CLSpinner';

import { Button } from './styled';
import { selectWebsiteTheme } from '../../store/slices/website';

const CLButton = ({
  children, onClick, loading, primary, icon, disabled, ...rest
}) => {
  const { colors } = useSelector(selectWebsiteTheme);

  return (
    <Button
      {...rest}
      $primary={primary?.toString()}
      $icon={icon?.toString()}
      $color={colors[0].color}
      $bColor={colors[6].color}
      $bgColor={colors[6].color}
      disabled={disabled}
      onClick={() => onClick()}
    >
      {loading ? <CLSpinner /> : children}
    </Button>
  );
};

CLButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  primary: PropTypes.bool,
  icon: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

CLButton.defaultProps = {
  loading: false,
  primary: false,
  disabled: false,
  icon: false,
};

export default CLButton;
